import { OpenInNew1OutlineIcon } from '@carboncopyco/icons';
import {
  ColorHex,
  Loading,
  TextCaption,
  TextTooltip,
  Tooltip,
} from '@carboncopyco/ui';
import { getMaxZIndex } from '@carboncopyco/utils';
import classNames from 'classnames';
import { useRef } from 'react';

type CreateSpreadsheetButtonProps = {
  isLoading: boolean;
  onClick: () => void;
};

export const CreateSpreadsheetButton = ({
  isLoading,
  onClick,
}: CreateSpreadsheetButtonProps) => {
  const currentRef = useRef(null);

  return (
    <>
      <div
        ref={currentRef}
        className={classNames(
          'flex items-center gap-1',
          !isLoading && 'cursor-pointer'
        )}
        onClick={() => {
          if (isLoading) return;
          onClick();
        }}
      >
        <TextCaption
          label="Edit with Sheets"
          color={isLoading ? 'text-ds-natural-200' : 'text-ds-primary-300'}
        />
        {isLoading ? (
          <Loading
            color="text-ds-primary-300"
            size={16}
          />
        ) : (
          <OpenInNew1OutlineIcon
            size={16}
            color={ColorHex.primary300}
          />
        )}
      </div>
      {!isLoading && (
        <Tooltip
          zIndex={getMaxZIndex() + 1}
          offset={[0, 2]}
          delay={[700, 0]}
          placement="top"
          anchorRef={currentRef}
          noArrow
          background="dark"
          shadow="lg"
        >
          <div className="px-1.5 pb-1 pt-0 leading-none">
            <TextTooltip
              label="Export table to edit with Google spreadsheets"
              color="text-ds-natural-50"
            />
          </div>
        </Tooltip>
      )}
    </>
  );
};
